import React from "react";
import {css} from "@emotion/react";

interface IProps {
    mainMessage?: string;
    subMessage?: string;
}

export const EmptyListMessage = (props: IProps) => {
    return (
        <div>
            {props.mainMessage && <p css={mainMessage}>{props.mainMessage}</p>}

            {props.subMessage && <p>{props.subMessage}</p>}
        </div>
    );
};

const mainMessage = css`
    font-size: 3rem;
    margin: 0;
    font-weight: 300;
`;
